import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconTodoPath = 'M17 0H3C1.346 0 0 1.346 0 3V24.961L3.919 22.92L6.772 24.948L10.035 22.941L12.994 24.956L16.062 22.91L20 24.961V3C20 1.346 18.654 0 17 0ZM18 21.664L15.938 20.59L13.006 22.544L10.09 20.559L6.853 22.552L4.081 20.58L2 21.664V3C2 2.448 2.449 2 3 2H17C17.551 2 18 2.448 18 3V21.664ZM12 19H5V17H12V19ZM5 15H15V13H5V15ZM6 8H9V11C12.541 8.818 13 6 13 6H10V3C6.459 5.182 6 8 6 8Z';
var NavigationIconTodoActivePath = 'M5 15H15V13H5V15ZM5 19H12V17H5V19ZM10 3V6H13C13 6 12.541 8.818 9 11V8H6C6 8 6.459 5.182 10 3ZM17 0H3C1.346 0 0 1.346 0 3V24.961L3.919 22.92L6.772 24.948L10.035 22.941L12.994 24.956L16.062 22.91L20 24.961V3C20 1.346 18.654 0 17 0Z';
var NavigationIcon = baseIcon('NavigationIconTodo', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconTodoActivePath : NavigationIconTodoPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: _objectSpread(_objectSpread({}, defaultNavigationIconGroupProps), {}, {
    x: 5,
    y: 3
  }),
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconTodo = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconTodo',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconTodo.displayName = 'NavigationIconTodo';
export default NavigationIconTodo;
//# sourceMappingURL=index.js.map